module.exports = __webpack_public_path__ + "static/media/badge-gold.f95870d3.png";